module.exports = __webpack_public_path__ + "static/media/laboratorios.a791187a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/modelo/laboratorios.svg
// module id = 192
// module chunks = 0